import { reportCardConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'reportCards';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	reportCards: [],
	reportCardsById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit report cards
		case reportCardConstants.SAVING_REPORT_CARD_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case reportCardConstants.SAVING_REPORT_CARD_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case reportCardConstants.SAVING_REPORT_CARD_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete report card
		case reportCardConstants.DELETE_REPORT_CARD_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case reportCardConstants.DELETE_REPORT_CARD_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case reportCardConstants.DELETE_REPORT_CARD_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load report cards
		case reportCardConstants.LOAD_REPORT_CARDS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case reportCardConstants.LOAD_REPORT_CARDS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case reportCardConstants.LOAD_REPORT_CARDS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/reportCard.reducers.js